import React, { Component } from 'react'
import '../styles/Dashboard.css'

class PieRegisteredFarmers extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			colors: ["#d33860", "#1f2d60"],
			// SAMPLE DATA ONLY
			data: {
				"Clustered Members": Math.floor(Math.random()*3001),
				"Non-Clustered Farmers": Math.floor(Math.random()*3001)
			},
			title: "REGISTERED FARMERS",
			subTitle: "OVERALL STATUS",
			ctLeft: 0
		}
		this.onResize = this.onResize.bind(this)
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this))
		this.onResize()
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this))
	}

	onResize() {
		console.log('pie onresize')
		const canvas = document.getElementById('pf-canvas')
		canvas.width = window.innerWidth * 0.25
		canvas.height = window.innerHeight * 0.25
		const legend = document.getElementById("pf-legend")
		const pieChart = new PieChart({
			canvas: canvas,
			data: this.state.data,
			colors: this.state.colors,
			legend: legend
		})
		pieChart.draw()
	}

	render() {
		const view = <div id="pie-farmers">
		<div class="pf-title">{this.state.title}</div>
		<div class="pf-subtitle">{this.state.subTitle}</div>
		<div class="pf-content"><canvas id="pf-canvas"/></div>
		<div class="pf-legend"><div id="pf-legend"></div></div>
	</div>
		return(view)
	}
}

const pieData = [];

const PieChart = function(props) {
	const canvas = props.canvas;
	this.ctx = props.canvas.getContext("2d");
	this.colors = props.colors;
	this.draw = () => {
		let totalValue = 0;
		let colorIndex = 0;
		for(var category in props.data) {
			var val = props.data[category];
			totalValue += val;
		}
		let startAngle = 1.57;
		let pieIndex = 0;
		for(category in props.data) {
			val = props.data[category];
			var sliceAngle = 2 * Math.PI * val / totalValue;
			pieData[pieIndex] = [];
			pieData[pieIndex]['startAngle'] = startAngle;
			pieData[pieIndex]['endAngle'] = startAngle+sliceAngle;
			pieData[pieIndex]['category'] = category;
			drawPieSlice(this.ctx, canvas.width/2, canvas.height/2,
				Math.min(canvas.width/2, canvas.height/2),
				startAngle, startAngle+sliceAngle,
				this.colors[colorIndex%this.colors.length]
			);
			startAngle += sliceAngle;
			colorIndex++;
			pieIndex++;
		}
		startAngle = 1.57;
		for(category in props.data) {
			val = props.data[category];
			sliceAngle = 2 * Math.PI * val / totalValue;
			const pieRadius = Math.min(canvas.width/2, canvas.height/2);
			const labelX = canvas.width/2 + (pieRadius/2) * Math.cos(startAngle+sliceAngle/2) * 1.4;
			const labelY = canvas.height/2 + (pieRadius/2) * Math.sin(startAngle+sliceAngle/2) * 1.4;
			const labelText = Math.round(100 * val / totalValue);
			this.ctx.fillStyle = "#FFFFFF";
			this.ctx.font = "12px roboto-bold";
			const str = labelText + "%";
			this.ctx.fillText(val, labelX-(str.length*3), labelY);
			startAngle += sliceAngle;
		}
		if(props.legend) {
			colorIndex = 0;
			var legendHTML = "";
			for(category in props.data) {
				legendHTML += "<div><div style='margin-right:15px'><span style='display:inline-block;width:12px;background-color:"
					+ this.colors[colorIndex++]
					+ ";'>&nbsp;</span> "
					+ category + "</div></div>";
			}
			props.legend.innerHTML = legendHTML;
		}
	}
}

const drawPieSlice = (ctx,centerX, centerY, radius, startAngle, endAngle, color) => {
	ctx.fillStyle = color;
	ctx.beginPath();
	ctx.moveTo(centerX,centerY);
	ctx.arc(centerX, centerY, radius, startAngle, endAngle);
	ctx.closePath();
	ctx.fill();
}

export default PieRegisteredFarmers
